module.exports = __webpack_public_path__ + "eebaae94c99485ce1f58bf82a84d057e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio4/08_4MCA Deine Raumkapsel.mp3
// module id = 794
// module chunks = 0